"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseVisualizer = void 0;
var event_dispatcher_1 = require("../../../base-utils/event-dispatcher");
var BaseVisualizer = (function () {
    function BaseVisualizer(control) {
        this.onChanged = new event_dispatcher_1.EventDispatcher();
        this.control = control;
        this.reset();
    }
    BaseVisualizer.prototype.closeDocument = function () {
        this.reset();
        this.raiseHide();
    };
    BaseVisualizer.prototype.reset = function () {
        this.pageIndex = -1;
        this.bounds = null;
        this.tip = null;
    };
    BaseVisualizer.prototype.hide = function () {
        this.reset();
        this.raiseHide();
    };
    BaseVisualizer.prototype.raiseShow = function () {
        var _this = this;
        this.onChanged.listeners.forEach(function (listener) { return listener.NotifyShow(_this.pageIndex, _this.bounds, _this.tip, _this.isTextBox, _this.isAnchoredObject, _this.rotation); });
    };
    BaseVisualizer.prototype.raiseHide = function () {
        this.onChanged.listeners.forEach(function (listener) { return listener.NotifyHide(); });
    };
    return BaseVisualizer;
}());
exports.BaseVisualizer = BaseVisualizer;
